import { css, cx } from "@emotion/css";
import type * as React from "react";
import * as styles from "./LegacyDataTableStyles";
export interface LegacyDataTableRowProps {
    displayNoBorder?: boolean;
    displayNoBottomBorderForLastRow?: boolean;
    className?: string;
    disabled?: boolean | null;
    onClick?: (e: React.MouseEvent<HTMLTableRowElement>) => void;
    children?: React.ReactNode;
}
export function LegacyDataTableRow({ displayNoBorder, className, disabled, displayNoBottomBorderForLastRow, children, ...otherProps }: LegacyDataTableRowProps): React.ReactElement {
    return (<tr {...otherProps} className={cx(styles.dataTableRow, { [noBorderStyle]: displayNoBorder, [noBottomBorderStyle]: displayNoBottomBorderForLastRow, [disabledStyle]: disabled }, className)}>
            {children}
        </tr>);
}
const noBorderStyle = css({
    border: "none",
    ":hover, :focus": {
        backgroundColor: "transparent",
    },
});
const noBottomBorderStyle = css({
    [`&:last-child`]: {
        borderBottom: "none",
    },
});
const disabledStyle = css({
    opacity: 0.4,
});
